import GCLOGO from '../GCLOGO.png';
import ProofProtectLogo from '../ProofProtectLogo.png';

export default function ComingSoon() {
  return (
    <div className="fog-page">
      <div className="fog-layer fog-layer--1" />
      <div className="fog-layer fog-layer--2" />
      <div className="fog-layer fog-layer--3" />
      <div className="fog-layer fog-layer--4" />
      <div className="fog-layer fog-layer--5" />

      <div className="relative z-10 flex flex-col items-center px-4 text-center select-none">
        <p
          className="text-sm md:text-base uppercase tracking-[0.5em] text-cyan-400/60 mb-6 font-light"
        >
          Stay tuned
        </p>

        <h1
          className="neon-text glitch-title text-5xl sm:text-7xl md:text-8xl lg:text-9xl font-bold uppercase tracking-[0.15em] leading-none"
        >
          Coming Soon
        </h1>

        <div className="mt-8 w-24 h-px bg-gradient-to-r from-transparent via-cyan-400/50 to-transparent" />

        <img src={GCLOGO} alt="Logo" className="h-8 mt-8 mx-auto object-contain" />
        <a href="https://proofprotect.com.au">
          <div className="mt-6 flex items-center justify-center gap-3">
          <img src={ProofProtectLogo} alt="ProofProtect" className="h-6 object-contain" />
          <div className="flex items-center gap-2 bg-black/40 backdrop-blur-md px-3 py-1 rounded-full">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" />
            </span>
            <span className="text-xs font-semibold uppercase tracking-wider text-white">Live</span>
          </div>
        </div>
        </a>
      </div>
    </div>
  );
}
